export default __webpack_public_path__ + "static/media/production.016739dc.svg";